// extracted by mini-css-extract-plugin
export default {"container":"FactsAndFeatures_container__ctrD2","itemContainer":"FactsAndFeatures_itemContainer__2IoWw"};